import { useSuspenseQuery } from '@apollo/client/react';
import { ExternalLink, Plus } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from 'src/components/ui/button';
import { StaticIntegrationsDialog } from 'src/containers/Integrations';
import { IntegrationsDocument } from 'src/graphql/actions/integration/integrations.query';

type Props = {
  canCreate: boolean;
};

const Header = ({ canCreate }: Props) => {
  const {
    data: { integrations: activeIntegrations },
  } = useSuspenseQuery(IntegrationsDocument, {
    variables: {
      page: 1,
      perPage: 0,
      active: true,
    },
  });
  const {
    data: { integrations: inactiveIntegrations },
  } = useSuspenseQuery(IntegrationsDocument, {
    variables: {
      page: 1,
      perPage: 0,
      active: false,
    },
  });

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
      <div className="space-y-1">
        <div className="text-base font-semibold text-gray-700">Your integrations</div>
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <span>{activeIntegrations.nodesCount} active</span>
          <span className="text-muted-foreground">•</span>
          <span>{inactiveIntegrations.nodesCount} disconnected</span>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:justify-center gap-3">
        <Button variant="outline" asChild size="sm">
          <Link to="https://codekeeper.co/integrations" target="_blank">
            Learn more <ExternalLink />
          </Link>
        </Button>
        {canCreate && (
          <StaticIntegrationsDialog
            dialogTrigger={
              <Button size="sm">
                <Plus />
                Add integration
              </Button>
            }
          />
        )}
      </div>
    </div>
  );
};

export default Header;
